// This file is generated by pnpm icons:generate. Do not edit.

import {CircleBanSign_Stroke2_Corner0_Rounded as CanonicalCircleBanSign_Stroke2_Corner0_Rounded} from './Circle'

/** @deprecated Import CircleBanSign_Stroke2_Corner0_Rounded from `#/components/icons/Circle` instead. */
export const CircleBanSign_Stroke2_Corner0_Rounded =
  CanonicalCircleBanSign_Stroke2_Corner0_Rounded
